var routes = [
  {
    path: 'overview',
    meta: {
      breadcrumb: 'Overview',
      path: 'home'
    },
    component: require('pages/backoffice/RouterViewPage.vue'),
    children: [
      {
        path: '',
        name: 'home',
        meta: {breadcrumb: 'Dashboard'},
        component: require('pages/backoffice/Home.vue'),
      },
      {
        path: 'visual',
        name: 'visual',
        meta: {breadcrumb: 'Visual'},
        component: require('pages/backoffice/WeekPlanner.vue'),
      },
      {
        path: 'fleet-map',
        name: 'fleet-map',
        meta: {breadcrumb: 'Fleet Map'},
        component: require('pages/backoffice/FleetMap.vue')
      },
      {
        path: 'sentinel',
        name: 'sentinel',
        meta: {breadcrumb: 'Sentinel'},
        component: require('pages/backoffice/Sentinel.vue')
      },
      {
        path: 'export',
        name: 'export',
        meta: {breadcrumb: 'Export'},
        component: require('pages/backoffice/Export.vue')
      },
      {
        path: 'cargo',
        name: 'cargo',
        meta: {breadcrumb: 'Cargo'},
        redirect: {name: 'cargos'},
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'cargos',
            component: require('pages/backoffice/Cargo.vue'),
          },
          {
            path: ':id',
            name: 'cargo-operation',
            component: require('pages/backoffice/controllers/CargoOperation.vue'),
            meta: {
              breadcrumb: '#CO',
              hideInMenu: true
            }
          }
        ]
      },
      {
        path: 'alarms',
        name: 'alarms',
        meta: {breadcrumb: 'Alarms'},
        component: require('pages/backoffice/Alarms.vue')
      },
      /*{
        path: 'allocation-status',
        name: 'allocation-status',
        meta: {breadcrumb: 'Allocation status'},
        component: require('pages/backoffice/AllocationStatus.vue')
      },*/

    ]
  },
  {
    path: 'todo',
    meta: {breadcrumb: 'Todo\'s'},
    component: require('pages/backoffice/RouterViewPage.vue'),
    name: 'todo-root',
    redirect: {name: 'client-approval'},
    children: [
      {
        path: 'client-approval',
        name: 'client-approval',
        meta: {breadcrumb: 'Client Approval'},
        component: require('pages/backoffice/ClientApprovalQueue.vue')
      },
      {
        path: 'driver-approval',
        name: 'driver-approval',
        meta: {breadcrumb: 'Driver Approval'},
        component: require('pages/backoffice/DriverApprovalQueue.vue')
      },
      {
        path: 'document-approval',
        name: 'document-approval',
        meta: {breadcrumb: 'Documents Approval'},
        component: require('pages/backoffice/DriverLicenseApprovalQueue.vue')
      },
      {
        path: 'reservation-approval',
        name: 'reservation-approval',
        meta: {breadcrumb: 'Reservation Approval'},
        component: require('pages/backoffice/ReservationsHoldBillingQueue.vue')
      },
      {
        path: 'pending-delete',
        name: 'pending-delete',
        meta: {breadcrumb: 'Delete requests'},
        component: require('pages/backoffice/DriverPendingDeleteQueue.vue')
      },
    ]
  },
  {
    path: 'customers',
    name: 'customers-root',
    redirect: {name: 'clients'},
    meta: {
      breadcrumb: 'Customers',
    },
    component: require('pages/backoffice/RouterViewPage.vue'),
    children: [
      ///
      {
        path: 'clients',
        meta: {
          path: 'clients',
          breadcrumb: 'Clients',
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'clients',
            component: require('pages/backoffice/ClientList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Client list',
            }
          },
          {
            path: 'add',
            name: 'create-client',
            meta: {
              breadcrumb: 'Add client',
              hideInMenu: true
            },
            component: require('pages/backoffice/CreateClient.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#CL',
              source: 'clients',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Client.vue'),
              action: {
                component: require('components/structure/ui/actions/ClientActionButtons.vue'),
              }
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'client',
                component: require('components/backoffice/tabbed/ClientProfile.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'profile',
                  breadcrumb: 'Profile',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'reservations',
                name: 'client-reservations',
                component: require('components/backoffice/tabbed/ClientReservations.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'reservations',
                  breadcrumb: 'Reservations',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'subscriptions',
                name: 'client-subscriptions',
                component: require('components/backoffice/tabbed/ClientSubscriptions.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'subscriptions',
                  breadcrumb: 'Subscriptions',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'drivers',
                name: 'client-drivers',
                component: require('components/backoffice/tabbed/ClientDrivers.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'drivers',
                  breadcrumb: 'Drivers',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'invoices',
                name: 'client-invoices',
                component: require('components/backoffice/tabbed/ClientInvoices.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'invoices',
                  breadcrumb: 'Invoices',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'credit-note/:wallet_id',
                name: 'credit-note',
                component: require('components/backoffice/tabbed/ClientCreditNote.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/ClientCreditNote.vue'),
                  name: 'credit-note',
                  breadcrumb: 'Credit Note',

                }
              },
              {
                path: 'transactions',
                name: 'client-transactions',
                component: require('components/backoffice/tabbed/ClientTransactions.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'transactions',
                  breadcrumb: 'Transactions',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'deposits',
                name: 'client-deposits',
                component: require('components/backoffice/tabbed/ClientDeposits.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'deposits',
                  breadcrumb: 'Reservations',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'payment-methods',
                name: 'client-payment-methods',
                component: require('components/backoffice/tabbed/ClientPaymentMethods.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'payment-methods',
                  breadcrumb: 'Payment methods',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'wallets',
                name: 'client-wallets',
                component: require('components/backoffice/tabbed/ClientWallets.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'wallets',
                  breadcrumb: 'Wallets',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'client-cards',
                component: require('components/backoffice/tabbed/ClientCards.vue'),
                name: 'client-cards',
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'client-cards',
                  breadcrumb: 'Cards',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
              {
                path: 'client-logs',
                name: 'client-logs',
                component: require('components/backoffice/tabbed/ClientLogs.vue'),
                meta: {
                  source: 'clients',
                  entityComponent: require('pages/backoffice/controllers/Client.vue'),
                  name: 'client-logs',
                  breadcrumb: 'Logs',
                  action: {
                    component: require('components/structure/ui/actions/ClientActionButtons.vue'),
                  }
                }
              },
            ],

          },
        ]
      },
      ///
      {
        path: 'drivers',
        meta: {
          path: 'drivers',
          breadcrumb: 'Drivers',
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '/',
            name: 'drivers',
            component: require('pages/backoffice/DriverList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Driver list',
            }
          },
          {
            path: 'add',
            name: 'create-driver',
            meta: {
              breadcrumb: 'Add driver',
              hideInMenu: true
            },
            component: require('pages/backoffice/CreateDriver.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#DR',
              source: 'drivers',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Driver.vue'),
              action: {
                component: require('components/structure/ui/actions/DriverActionButtons.vue'),
              }
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'driver',
                component: require('components/backoffice/tabbed/DriverProfile.vue'),
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'profile',
                  breadcrumb: 'Profile',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
              {
                path: 'reservations',
                name: 'driver-reservations',
                component: require('components/backoffice/tabbed/DriverReservations.vue'),
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'driver-reservations',
                  breadcrumb: 'Reservations',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
              {
                path: 'subscriptions',
                component: require('components/backoffice/tabbed/DriverSubscriptions.vue'),
                name: 'driver-subscriptions',
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'subscriptions',
                  breadcrumb: 'Subscriptions',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
              {
                path: 'driver-licenses',
                component: require('components/backoffice/tabbed/DriverLicenses.vue'),
                name: 'driver-licenses',
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'driver-licenses',
                  breadcrumb: 'Driver licenses',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
              {
                path: 'driver-coupons',
                component: require('components/backoffice/tabbed/DriverCoupons.vue'),
                name: 'driver-coupons',
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'driver-coupons',
                  breadcrumb: 'Driver coupons',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
              {
                path: 'driver-cards',
                component: require('components/backoffice/tabbed/DriverCards.vue'),
                name: 'driver-cards',
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'driver-cards',
                  breadcrumb: 'Driver cards',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
              {
                path: 'driver-tocs',
                component: require('components/backoffice/tabbed/DriverTocs.vue'),
                name: 'driver-tocs',
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'driver-tocs',
                  breadcrumb: 'Driver tocs',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
              {
                path: 'driver-logs',
                component: require('components/backoffice/tabbed/DriverLogs.vue'),
                name: 'driver-logs',
                meta: {
                  source: 'drivers',
                  entityComponent: require('pages/backoffice/controllers/Driver.vue'),
                  name: 'driver-logs',
                  breadcrumb: 'Logs',
                  action: {
                    component: require('components/structure/ui/actions/DriverActionButtons.vue'),
                  }
                }
              },
            ]
          },
        ],
      },

      {
        path: 'subscriptions',
        component: require('pages/backoffice/RouterViewPage.vue'),
        meta: {
          path: 'subscriptions',
          breadcrumb: 'Subscriptions'
        },
        children: [
          {
            path: '/',
            name: 'subscriptions',
            meta: {
              breadcrumb: 'Subscription list'
            },
            component: require('pages/backoffice/SubscriptionList.vue')
          },
          {
            path: ':id',
            name: 'subscription',
            component: require('pages/backoffice/EntityPage.vue'),
            meta: {
              breadcrumb: '#S',
              hideInMenu: true,
              source: 'subscriptions',
              entityComponent: require('pages/backoffice/controllers/Subscription.vue'),
              name: 'Subscription',
              action: {
                component: require('components/structure/ui/actions/SubscriptionActionButtons.vue'),
              }
            },
          },
        ]
      },

      {
        path: 'cards',
        name: 'cards',
        meta: {
          breadcrumb: 'Cards',
          action: {
            component: require('components/structure/ui/actions/CreateEntityButton.vue'),
            path: 'add-card'
          },
        },
        component: require('pages/backoffice/CardList.vue')
      },
      {
        path: 'add-card',
        name: 'add-card',
        meta: {
          breadcrumb: 'New card',
          hideInMenu: true,
        },
        component: require('components/structure/ui/CreateCard.vue')
      },
      {
        path: 'notifications',
        name: 'notifications',
        meta: {
          breadcrumb: 'Notifications',
        },
        component: require('pages/backoffice/NotificationsList.vue')
      },
      {
        path: 'registration-tokens',
        meta: {
          breadcrumb: 'Registration Tokens',
          path: 'registration-tokens'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'registration-tokens',
            component: require('pages/backoffice/RegistrationTokenList.vue'),
            meta: {
              breadcrumb: '',
              action: {
                component: require('pages/backoffice/RegistrationTokenReveal.vue'),
                path: 'add',
              },
            },
          },

        ]
      },
    ]
  },
  {
    path: 'booking',
    meta: {
      breadcrumb: 'Booking',
    },
    name: 'booking-root',
    redirect: {name: 'reservations'},
    component: require('pages/backoffice/RouterViewPage.vue'),
    children: [
      {
        path: 'reservations',
        meta: {
          breadcrumb: 'Reservations',
          path: 'reservations',
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'reservations',
            component: require('pages/backoffice/ReservationList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'List'
            }
          },
          {
            path: 'add',
            name: 'Create reservation',
            meta: {
              breadcrumb: 'New reservation',
              hideInMenu: true,
            },
            component: require('components/structure/ui/BookPanel.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#R',
              source: 'reservations',
              hideInMenu: true,

            },
            children: [
              {
                path: '',
                name: 'reservation',
                meta: {
                  source: 'reservations',
                  entityComponent: require('pages/backoffice/controllers/Reservation.vue'),
                  name: 'reservation',
                  action: {
                    component: require('components/structure/ui/actions/ReservationActionButtons.vue'),
                  }
                }
              },
              {
                path: 'replace-vehicle',
                name: 'replace-vehicle',
                meta: {
                  source: 'reservations',
                  entityComponent: require('pages/backoffice/controllers/FindAReplaceVehicle.vue'),
                  name: 'reservation',
                  breadcrumb: 'Replace vehicle',
                  action: {
                    component: require('components/structure/ui/actions/ReservationActionButtons.vue'),
                  }
                }
              },
              {
                path: 'report-reservation',
                name: 'report-resevation',
                meta: {
                  source: 'reservations',
                  entityComponent: require('pages/backoffice/controllers/ReportReservation.vue'),
                  name: 'report-reservation',
                  breadcrumb: 'Reservation report',
                  /*action: {
                    component: require('components/structure/ui/actions/ReservationActionButtons.vue'),
                  }*/
                }
              },
            ],

            component: require('pages/backoffice/EntityPage.vue')
          },
        ],
      },
      {
        path: 'reservation-planner',
        name: 'reservation-planner',
        meta: {breadcrumb: 'Planner'},
        component: require('pages/backoffice/ReservationPlanner.vue')
      },
      {
        path: 'charge-sessions',
        name: 'charge-sessions',
        meta: {
          breadcrumb: 'Charging sessions',
          action: {
            component: require('pages/backoffice/ChargingSessionReveal.vue'),
            path: 'add',
            //props: {item: null}
          },
        },
        component: require('pages/backoffice/ChargingSessionsList.vue')
      },
      {
        path: 'reservation-request',
        name: 'reservation-request',
        meta: {breadcrumb: 'Requests'},
        component: require('pages/backoffice/DriversReservationRequestList.vue')
      },
      {
        path: 'transit',
        name: 'transit',
        meta: {breadcrumb: 'Transit'},
        component: require('pages/backoffice/TransitList.vue')
      }
    ]
  },
  {
    path: 'billing',
    meta: {
      breadcrumb: 'Billing',
    },
    name: 'billing-root',
    redirect: {name: 'invoices'},
    component: require('pages/backoffice/RouterViewPage.vue'),
    children: [
      {
        path: 'invoices',
        meta: {
          breadcrumb: 'Invoices',
          path: 'invoices',
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'invoices',
            component: require('pages/backoffice/InvoiceList.vue'),
            meta: {
              breadcrumb: 'Invoice list',
            },
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#INV',
              source: 'invoices',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Invoice.vue'),
              action: {
                component: require('components/structure/ui/actions/InvoiceButtons.vue'),
              }
            },
            children: [
              {
                path: '',
                name: 'invoice',
                component: require('components/backoffice/Invoice.vue'),
                meta: {
                  source: 'invoices',
                  entityComponent: require('pages/backoffice/controllers/Invoice.vue'),
                  name: 'invoice',
                  breadcrumb: 'invoice',
                  action: {
                    component: require('components/structure/ui/actions/InvoiceButtons.vue'),
                  }
                }
              },
            ],
            component: require('pages/backoffice/EntityPage.vue')
          },
        ]
      },
      {
        path: 'transactions',
        meta: {
          breadcrumb: 'Transactions',
          path: 'transactions'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'transactions',
            component: require('pages/backoffice/TransactionList.vue'),
            meta: {
              breadcrumb: 'Transactions'
            },
          },
          {
            path: ':id',
            name: 'transaction',
            component: require('components/backoffice/tabbed/Transaction.vue'),
            meta: {
              breadcrumb: '#TR',
              source: 'transactions',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Transaction.vue'),
              action: {
                component: require('components/structure/ui/actions/TransactionButtons.vue'),
              }
            }
          }
        ]
      },
      {
        path: 'pending-records',
        meta: {
          breadcrumb: 'Pending records',
          path: 'pending-records'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'pending-records',
            component: require('pages/backoffice/PendingRecordsList.vue'),

          },
        ]
      },
      {
        path: 'coupons',
        meta: {
          breadcrumb: 'Coupons',
          path: 'coupons'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'coupons',
            component: require('pages/backoffice/CouponList.vue'),
            meta: {
              breadcrumb: 'Coupons',
              action: {
                component: require('pages/backoffice/CouponReveal.vue'),
                path: 'add',
                //props: {item: null}
              },
            },
          },

        ]
      },
      {
        path: 'coupons-list',
        meta: {
          breadcrumb: 'Coupons List',
          path: 'coupons-list'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'coupons-list',
            component: require('pages/backoffice/CouponInUseList.vue'),
            meta: {
              breadcrumb: 'Coupons List',
            },

          },

        ]
      }
    ]
  },
  {
    path: 'assets',
    meta: {breadcrumb: 'Assets'},
    name: 'assets-root',
    redirect: {name: 'vehicles'},
    component: require('pages/backoffice/RouterViewPage.vue'),

    children: [
      {
        path: 'categories',
        meta: {
          breadcrumb: 'Vehicle Categories',
          path: 'categories'

        },
        children: [
          {
            path: '',
            name: 'categories',
            component: require('pages/backoffice/CategoryList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              }
            }
          },
          {
            path: 'add',
            name: 'create-category',
            meta: {breadcrumb: 'Add Vehicle Category', hideInMenu: true},
            component: require('pages/backoffice/CreateVehicleCategory.vue')
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')

        //component: require('pages/backoffice/CategoryList.vue')
      },
      {
        path: 'types',
        meta: {
          breadcrumb: 'Vehicle types',
          path: 'types'

        },
        children: [
          {
            path: '',
            name: 'types',
            component: require('pages/backoffice/VehicleTypesList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              }
            }
          },
          {
            path: 'add',
            name: 'create-vehicle-type',
            meta: {breadcrumb: 'Add vehicle type', hideInMenu: true},
            component: require('pages/backoffice/CreateVehicleType.vue')
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'management',
        meta: {
          breadcrumb: 'Management',
          path: 'management'
        },
        children: [
          {
            path: '',
            name: 'management',
            component: require('pages/backoffice/AssetManagement.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add-parking-group'
              },
              breadcrumb: 'Parking Groups',

            },
          },
          {
            path: 'add-parking-group',
            name: 'add-parking-group',
            meta: {breadcrumb: 'Add Parking Group', hideInMenu: true},
            component: require('components/structure/ui/actions/CreateParkingGroup.vue')
          },

          {
            path: ':id',
            meta: {
              breadcrumb: '#PL',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/ParkingLot.vue')
            },
            children: [
              {
                path: '',
                name: 'parkingLot',
                component: require('components/backoffice/tabbed/ParkingLotsOverview.vue'),
                meta: {
                  source: 'parkingLots',
                  entityComponent: require('pages/backoffice/controllers/ParkingLot.vue'),
                  name: 'parkingLot',
                  breadcrumb: 'Manage',
                  action: {
                    component: require('components/structure/ui/actions/ParkingLotActionButtons.vue'),
                  }
                }
              },
              {
                path: 'manage',
                name: 'manage',
                component: require('components/backoffice/tabbed/ParkingLotsManage.vue'),
                meta: {
                  source: 'parkingLots',
                  entityComponent: require('pages/backoffice/controllers/ParkingLot.vue'),
                  name: 'manage',
                  breadcrumb: 'Manage',
                  action: {
                    component: require('components/structure/ui/actions/ParkingLotActionButtons.vue'),
                  }
                }
              },
              {
                path: 'zones',
                name: 'zones',
                component: require('components/backoffice/tabbed/ParkingLotZones.vue'),
                meta: {
                  source: 'parkingLots',
                  entityComponent: require('pages/backoffice/controllers/ParkingLot.vue'),
                  name: 'zones',
                  breadcrumb: 'Zones',
                  action: {
                    component: require('components/structure/ui/actions/ParkingLotActionButtons.vue'),
                  }
                }
              },
              {
                path: 'add-parking-lot',
                name: 'add-parking-lot',
                meta: {
                  breadcrumb: 'Add Parking Lot', hideInMenu: true,
                  source: 'parkingGroups',
                  entityComponent: require('components/structure/ui/actions/CreateParkingLot.vue'),
                  name: 'parkingLots',
                },
                component: require('components/structure/ui/actions/CreateParkingLot.vue')
              },
            ],
            component: require('pages/backoffice/EntityPage.vue')

          }

        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },

      // {
      //   path: 'hardware',
      //   meta: {
      //     breadcrumb: 'Hardware List',
      //     path: 'hardware'
      //   },
      //   children: [
      //     {
      //       path: '',
      //       name: 'hardware',
      //       component: require('pages/backoffice/VehicleHardwareList.vue'),
      //       /*meta: {
      //         action: {
      //           component: require('components/structure/ui/actions/CreateEntityButton.vue'),
      //           path: 'add-parking-group'
      //         }
      //       }*/
      //     }
      //   ],
      //   component: require('pages/backoffice/RouterViewPage.vue')
      // },
      {
        path: 'operations',
        meta: {
          breadcrumb: 'Operations',
          path: 'operations',
          hideInMenu: true
        },
        children: [
          {
            path: ':id',
            meta: {
              breadcrumb: '#VS',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Operations.vue')
            },
            children: [
              {
                path: '',
                name: 'operations',
                //component: require('components/backoffice/tabbed/ParkingLotOverview.vue'),
                meta: {
                  source: 'vehicleSlots',
                  entityComponent: require('pages/backoffice/controllers/Operations.vue'),
                  name: 'operations',
                  breadcrumb: 'Drain',

                }
              }
            ],
            component: require('pages/backoffice/EntityPage.vue')

          }

        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'vehicles',
        meta: {
          breadcrumb: 'Vehicles',
          path: 'vehicles'
        },
        children: [
          {
            path: '',
            name: 'vehicles',
            component: require('pages/backoffice/VehicleList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Vehicle list',
            }
          },
          {
            path: 'add',
            name: 'create-vehicle',
            meta: {breadcrumb: 'Add vehicle', hideInMenu: true},
            component: require('pages/backoffice/CreateVehicle.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#V',
              source: 'vehicles',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Vehicle.vue')
            },
            children: [
              {
                path: '',
                name: 'vehicle',
                component: require('components/backoffice/tabbed/VehicleOverview.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle',
                  breadcrumb: 'Overview',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'availability',
                name: 'vehicle-availability',
                component: require('components/backoffice/tabbed/VehicleAvailability.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-availability',
                  breadcrumb: 'Availability',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'reports',
                name: 'vehicle-reports',
                component: require('components/backoffice/tabbed/VehicleReports.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-reports',
                  breadcrumb: 'Reports',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'maintenance-requests',
                name: 'maintenance-requests',
                component: require('components/backoffice/tabbed/VehicleInterventionRequests.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'maintenance-requests',
                  breadcrumb: 'Maintenance requests',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'reservations',
                name: 'vehicle-reservations',
                component: require('components/backoffice/tabbed/VehicleReservations.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-reservations',
                  breadcrumb: 'Reservations',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'position',
                name: 'vehicle-position',
                component: require('components/backoffice/tabbed/VehicleMapPosition.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-position',
                  breadcrumb: 'Position',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'costs',
                name: 'vehicle-costs',
                component: require('components/backoffice/tabbed/VehicleCosts.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-costs',
                  breadcrumb: 'Costs',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'notes',
                name: 'vehicle-notes',
                component: require('components/backoffice/tabbed/VehicleNotes.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-notes',
                  breadcrumb: 'Notes',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'instructions',
                name: 'vehicle-instructions',
                component: require('components/backoffice/tabbed/VehicleInstructions.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-instructions',
                  breadcrumb: 'Instructions',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'attributes',
                name: 'vehicle-attributes',
                component: require('components/backoffice/tabbed/VehicleAttributes.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-attributes',
                  breadcrumb: 'Attributes',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              },
              {
                path: 'logs',
                name: 'vehicle-logs',
                component: require('components/backoffice/tabbed/VehicleSlotLogs.vue'),
                meta: {
                  source: 'vehicles',
                  entityComponent: require('pages/backoffice/controllers/Vehicle.vue'),
                  name: 'vehicle-logs',
                  breadcrumb: 'Logs',
                  action: {
                    component: require('components/structure/ui/actions/VehicleSlotButtons.vue'),
                  }
                }
              }
            ],
            component: require('pages/backoffice/EntityPage.vue')

          }

        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },

      /*{
        path: 'vehicle-slot-list',
        name: 'vehicle-slot-list',
        meta: {
          breadcrumb: 'Vehicle Slots',
        },
        component: require('pages/backoffice/VehicleSlotList.vue')
      },*/
      {
        path: 'notes-management',
        meta: {
          breadcrumb: 'Notes',
          path: 'notes-management'
        },
        children: [
          {
            path: '',
            name: 'notes-management',
            component: require('pages/backoffice/NoteList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
            }
          },
          {
            path: 'add',
            name: 'create-note',
            meta: {breadcrumb: 'Add Global Note', hideInMenu: true},
            component: require('pages/backoffice/CreateNote.vue')
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'attributes',
        meta: {
          breadcrumb: 'Attributes',
          path: 'attributes'
        },
        children: [
          {
            path: '',
            name: 'attributes',
            component: require('pages/backoffice/VehicleAttributeList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Attribute list',
            }
          },
          {
            path: 'add',
            name: 'create-attribute',
            meta: {breadcrumb: 'Add attribute', hideInMenu: true},
            component: require('pages/backoffice/CreateVehicleAttribute.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#VA',
              source: 'vehicleAttributes',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Plan.vue'),
            },
            children: [
              {
                path: '',
                name: 'attribute',
                component: require('pages/backoffice/CreateVehicleAttribute.vue'),
                meta: {
                  source: 'vehicleAttributes',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'attribute',
                }
              },

            ],
            component: require('pages/backoffice/EntityPage.vue')
          }
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'zone-management',
        meta: {
          breadcrumb: 'Zones',
          path: 'zone-management'
        },
        children: [
          {
            path: '',
            name: 'zone-management',
            component: require('pages/backoffice/ZoneList.vue'),
            meta: {
              action: [
                {
                  component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                  path: 'add'
                },
                {
                  component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                  path: 'merge'
                },
              ]
            }
          },
          {
            path: 'merge',
            name: 'merge-zone',
            meta: {breadcrumb: 'Merge zone', hideInMenu: true},
            component: require('pages/backoffice/MergeZone.vue')
          },
          {
            path: 'add',
            name: 'create-zone',
            meta: {breadcrumb: 'Add zone', hideInMenu: true},
            component: require('pages/backoffice/CreateZone.vue')
          },
          {
            path: ':id/edit',
            name: 'edit-zone',
            meta: {breadcrumb: 'Edit zone', hideInMenu: true},
            component: require('pages/backoffice/EditZone.vue')
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'clone',
        meta: {
          breadcrumb: 'Clone Vehicle',
          path: 'clone'
        },
        children: [
          {
            path: '',
            name: 'clone',
            component: require('pages/backoffice/CloneVehicle.vue'),
            /*meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add-parking-group'
              }
            }*/
          }
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'segments',
        meta: {
          breadcrumb: 'Segments',
          path: 'segments'
        },
        children: [
          {
            path: '',
            name: 'segments',
            component: require('pages/backoffice/SegmentList.vue'),
            meta: {}
          }
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      }
    ]
  },
  {
    path: 'support',
    name: 'support-root',
    meta: {breadcrumb: 'Support'},
    redirect: {name: 'reportings'},
    component: require('pages/backoffice/RouterViewPage.vue'),
    children: [
      {
        path: 'reportings',
        meta: {
          breadcrumb: 'Reporting List',
          path: 'reportings'
        },
        children: [
          {
            path: '',
            name: 'reportings',
            component: require('pages/backoffice/ReportingList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'create-reporting'
              },
              breadcrumb: 'Reporting List',
            }
          },
          {
            path: 'create-reporting/:vehicleId?',
            name: 'create-reporting',
            meta: {
              breadcrumb: 'New reporting',
              hideInMenu: true,
            },
            component: require('pages/backoffice/CreateReporting.vue')
          },
          {
            path: ':id',
            name: 'reporting',
            meta: {
              breadcrumb: '#RP',
              source: 'reportings',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Reporting.vue'),
              action: {
                component: require('components/structure/ui/actions/ReportingActionButtons.vue'),
              }
            },
            children: [
              {
                path: 'edit',
                name: 'edit-reporting',
                entityComponent: require('pages/backoffice/EditReporting.vue'),
                meta: {
                  source: 'reportings',
                  entityComponent: require('pages/backoffice/EditReporting.vue'),
                  name: 'reportings',
                  breadcrumb: 'Edit'
                }
              },
            ],

            component: require('pages/backoffice/EntityPage.vue')
          }
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'reporting-types',
        meta: {
          breadcrumb: 'Reporting type List',
          path: 'reporting-types'
        },
        children: [
          {
            path: '',
            name: 'reporting-types',
            component: require('pages/backoffice/ReportingTypesList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateReportingTypeButtonModal.vue'),
                path: 'create-reporting'
              },
            }
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'intervention-request',
        meta: {
          breadcrumb: 'Maintenance request',
          path: 'intervention-request',

        },
        children: [
          {
            path: '',
            name: 'intervention-request',
            component: require('pages/backoffice/MaintenanceRequestList.vue'),
            meta: {
              action: {
                component: require('pages/backoffice/CreateInterventionRequestReveal.vue'),
                path: 'add',
                //props: {item: null}
              },
            }
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'instructions',
        meta: {
          breadcrumb: 'Vehicle Instructions',
          path: 'instructions'
        },
        children: [
          {
            path: '',
            name: 'instructions',
            component: require('pages/backoffice/InstructionList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'create-instruction'
              },
              breadcrumb: '',
            }
          },
          {
            path: 'create-instruction/',
            name: 'create-instruction',
            meta: {
              breadcrumb: 'New instruction',
              hideInMenu: true,
            },
            component: require('pages/backoffice/CreateInstruction.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#IN',
              source: 'instructions',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Toc.vue'),
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'instruction',
                component: require('pages/backoffice/CreateInstruction.vue'),
                meta: {
                  source: 'instructions',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'update',
                  breadcrumb: 'Update',
                }
              },
            ]
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
    ]
  },
  {
    path: 'config',
    name: 'config-root',
    meta: {breadcrumb: 'Configuration'},
    redirect: {name: 'plans'},
    component: require('pages/backoffice/RouterViewPage.vue'),
    children: [
      {
        path: 'system',
        name: 'system',
        meta: {breadcrumb: 'System'},
        component: require('pages/backoffice/Configuration.vue')
      },

      {
        path: 'plans',
        meta: {
          breadcrumb: 'Plans',
          path: 'plans'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'plans',
            component: require('pages/backoffice/PlanList.vue'),
            meta: {
              action: {
                component: require('pages/backoffice/PlanReveal.vue'),
                path: 'add'
              },
              breadcrumb: 'Plan list',
            }
          },
          {
            path: 'add',
            name: 'create-plan',
            meta: {
              breadcrumb: 'Add plan',
              hideInMenu: true
            },
            component: require('pages/backoffice/CreatePlan.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#PL',
              source: 'plans',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Plan.vue'),
              action: {
                component: require('components/structure/ui/actions/PlanActionButtons.vue'),
              }
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'plan',
                component: require('components/backoffice/tabbed/PlanSetup.vue'),
                meta: {
                  source: 'plans',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'setup',
                  breadcrumb: 'Setup',
                  action: {
                    component: require('components/structure/ui/actions/PlanActionButtons.vue'),
                  }
                }
              },
              {
                path: 'plan-reservation-rates',
                name: 'plan-reservation-rates',
                component: require('components/backoffice/tabbed/PlanReservationRates.vue'),
                meta: {
                  source: 'plans',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'rates',
                  breadcrumb: 'Plan reservation rates'
                },
              },
              {
                path: ':rateId/edit',
                name: 'edit-plan-reservation-rates',
                component: require('components/backoffice/tabbed/EditPlanReservationRates.vue'),
                meta: {
                  source: 'plans',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'rates',
                  breadcrumb: 'Edit'
                },

              },
              {
                path: 'add-plan-reservation-rate',
                name: 'add-plan-reservation-rates',
                component: require('components/backoffice/tabbed/CreatePlanReservationRates.vue'),
                meta: {
                  source: 'plans',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'rates',
                  breadcrumb: 'New'
                },

              },
            ]
          },
        ]
      },
      {
        path: 'rates',
        meta: {
          breadcrumb: 'Rates',
          path: 'rates'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),

        children: [
          {
            path: 'add-rate',
            name: 'add-rate',
            component: require('components/backoffice/tabbed/RateConfiguration.vue'),
            meta: {
              breadcrumb: 'Add Rate',
            }
          },
          {
            path: '',
            name: 'rates',
            component: require('pages/backoffice/ReservationRateList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add-rate'
              },
              breadcrumb: 'Rate list',
            }
          },

          {
            path: ':id',
            meta: {
              breadcrumb: '#R',
              source: 'reservationRates',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Plan.vue'),
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'configuration-rate',
                component: require('components/backoffice/tabbed/RateConfiguration.vue'),
                meta: {
                  source: 'reservationRates',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'setup',
                  breadcrumb: 'Setup',
                }
              },

            ]
          },

        ]
      },
      {
        path: 'tocs',
        meta: {
          breadcrumb: 'Tocs',
          path: 'tocs'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'tocs',
            component: require('pages/backoffice/TocList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Toc list',
            }
          },
          {
            path: 'add',
            name: 'create-toc',
            meta: {
              breadcrumb: 'Add toc',
              hideInMenu: true
            },
            component: require('pages/backoffice/CreateToc.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#TOC',
              source: 'tocs',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Toc.vue'),
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'toc',
                component: require('pages/backoffice/CreateToc.vue'),
                meta: {
                  source: 'tocs',
                  entityComponent: require('pages/backoffice/controllers/Plan.vue'),
                  name: 'update',
                  breadcrumb: 'Update',
                }
              },
            ]
          },
        ]
      },
      {
        path: 'policies',
        meta: {
          breadcrumb: 'Policies',
          path: 'policies'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'policies',
            component: require('pages/backoffice/PolicyList.vue'),
            meta: {
              action: {
                component: require('pages/backoffice/PolicyReveal.vue'),
                path: 'add',
                //props: {item: null}
              },
              breadcrumb: 'Policy list',
            }
          },


        ]
      },
      {
        path: 'groups',
        meta: {
          breadcrumb: 'Groups',
          path: 'groups'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'groups',
            component: require('pages/backoffice/GroupList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Group list',
            }
          },
          {
            path: 'add',
            name: 'create-group',
            meta: {
              breadcrumb: 'Add group',
              hideInMenu: true
            },
            component: require('pages/backoffice/GroupEdit.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#G',
              source: 'groups',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Toc.vue'),
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'group',
                component: require('pages/backoffice/GroupEdit.vue'),
                meta: {
                  source: 'groups',
                  entityComponent: require('pages/backoffice/GroupEdit.vue'),
                  name: 'update',
                  breadcrumb: 'Update',
                }
              },
            ]
          },
        ]
      },
      {
        path: 'federations',
        meta: {
          breadcrumb: 'Federations',
          path: 'federations'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'federations',
            component: require('pages/backoffice/FederationList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'List',
            }
          },
          {
            path: 'add',
            name: 'create-federation',
            meta: {
              breadcrumb: 'Add federation',
              hideInMenu: true
            },
            component: require('pages/backoffice/FederationAdd.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#F',
              source: 'federations',
              hideInMenu: true,
              entityComponent: require('pages/backoffice/controllers/Federation.vue'),
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: 'vehicles',
                name: 'federation-vehicles',
                component: require('pages/backoffice/FederationVehiclesEdit.vue'),
                meta: {
                  source: 'federationVehicles',
                  entityComponent: require('pages/backoffice/controllers/Federation.vue'),
                  name: 'federationVehicles',
                  breadcrumb: 'Vehicles',
                }
              },
              {
                path: 'parking-groups',
                name: 'federation-parking-groups',
                component: require('pages/backoffice/FederationParkingGroupsEdit.vue'),
                meta: {
                  source: 'federationParkingGroups',
                  entityComponent: require('pages/backoffice/controllers/Federation.vue'),
                  name: 'federationParkingGroups',
                  breadcrumb: 'Parking Groups',
                }
              },
              {
                path: 'clients',
                name: 'federation-clients',
                component: require('pages/backoffice/FederationClientsEdit.vue'),
                meta: {
                  source: 'federationClients',
                  entityComponent: require('pages/backoffice/controllers/Federation.vue'),
                  name: 'federationClients',
                  breadcrumb: 'Clients',
                }
              },
            ],
          },
        ]
      },
      {
        path: 'users',
        meta: {
          breadcrumb: 'Users',
          path: 'users'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'users',
            component: require('pages/backoffice/UserList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'User list',
            }
          },
          {
            path: 'add',
            name: 'create-user',
            meta: {
              breadcrumb: 'Add user',
              hideInMenu: true
            },
            component: require('pages/backoffice/UserEdit.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#U',
              source: 'users',
              hideInMenu: true,
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'user',
                meta: {
                  source: 'users',
                  entityComponent: require('pages/backoffice/UserEdit.vue'),
                  name: 'update',
                  breadcrumb: 'Update',
                }
              },
            ]
          },
        ]
      },
      {
        path: 'roles',
        meta: {
          breadcrumb: 'Roles',
          path: 'roles'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'roles',
            component: require('pages/backoffice/RoleList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Role list',
            }
          },
          {
            path: 'add',
            name: 'create-role',
            meta: {
              breadcrumb: 'Add Role',
              hideInMenu: true
            },
            component: require('pages/backoffice/RoleEdit.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#RL',
              source: 'roles',
              hideInMenu: true,
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'role',
                meta: {
                  source: 'roles',
                  entityComponent: require('pages/backoffice/RoleEdit.vue'),
                  name: 'update',
                  breadcrumb: 'Update',
                }
              },
            ]
          },
        ]
      },
      {
        path: 'translations',
        meta: {
          breadcrumb: 'Translations',
          path: 'translations'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'translations',
            component: require('pages/backoffice/TranslationList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Translation list',
            }
          },
          {
            path: 'add',
            name: 'create-translation',
            meta: {
              breadcrumb: 'Add Translation',
              hideInMenu: true
            },
            component: require('pages/backoffice/TranslationAdd.vue'),
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#TR',
              source: 'translations',
              hideInMenu: true,
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: '',
                name: 'translation',
                meta: {
                  source: 'translations',
                  entityComponent: require('pages/backoffice/TranslationEdit.vue'),
                  name: 'update',
                  breadcrumb: 'Update',
                }
              },
            ]
          },
        ]
      },
      {
        path: 'toc-types',
        meta: {
          breadcrumb: 'Toc types',
          path: 'toc-types'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'toc-types',
            component: require('pages/backoffice/TocTypeList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateTocTypeButtonModal.vue'),
                path: 'add'
              },
              breadcrumb: 'Toc type list',
            }
          },
        ]
      },
      {
        path: 'document-types',
        meta: {
          breadcrumb: 'Document types',
          path: 'document-types'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'document-types',
            component: require('pages/backoffice/DocumentTypeList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateDocumentTypeButtonModal.vue'),
                path: 'add'
              },
              breadcrumb: 'Document type list',
            }
          },
        ]
      },
      {
        path: 'common-costs',
        meta: {
          breadcrumb: 'Common Costs',
          path: 'common-costs'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'common-costs',
            component: require('pages/backoffice/CommonCostList.vue'),
            meta: {
              breadcrumb: 'Cost list',
            }
          },
        ]
      },
      {
        path: 'common-cost-types',
        meta: {
          breadcrumb: 'Common Cost Types',
          path: 'common-cost-types'

        },
        children: [
          {
            path: '',
            name: 'common-cost-types',
            component: require('pages/backoffice/CommonCostTypeList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              }
            }
          },
          {
            path: 'add',
            name: 'create-common-cost-type',
            meta: {breadcrumb: 'Add common cost type', hideInMenu: true},
            component: require('pages/backoffice/CreateCommonCostType.vue')
          },
        ],
        component: require('pages/backoffice/RouterViewPage.vue')
      },
      {
        path: 'packets',
        meta: {
          breadcrumb: 'Packets',
          path: 'packets'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'packets',
            component: require('pages/backoffice/PacketList'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/reveal/CreatePacketReveal.vue'),
                path: 'add'
              },
              breadcrumb: 'Packet list',
            }
          },
        ]
      },
      {
        path: 'packet-category',
        meta: {
          breadcrumb: 'packet category',
          path: 'packet-category'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'packet-category',
            component: require('pages/backoffice/PacketVehicleCategoryList'),
            meta: {
              breadcrumb: 'packet category list',
            }
          },
        ]
      },
      {
        path: 'requirements',
        meta: {
          breadcrumb: 'Requirements',
          path: 'requirements'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'requirements',
            component: require('pages/backoffice/DocumentRequirementList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateDocumentRequirementButtonModal.vue'),
                path: 'add'
              },
              breadcrumb: 'Requirement list',
            }
          },
        ]
      },
      {
        path: 'console',
        meta: {
          breadcrumb: 'Console',
          path: 'console'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'console',
            component: require('pages/backoffice/Console.vue'),
            meta: {
              breadcrumb: 'Console',
            }
          },
        ]
      },

      {
        path: 'client-types',
        meta: {
          breadcrumb: 'Client types',
          path: 'client-types'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'client-types',
            component: require('pages/backoffice/ClientTypeList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateClientTypeButtonModal.vue'),
                path: 'add'
              },
              breadcrumb: 'Client type list',
            }
          },
        ]
      },
      {
        path: 'vats',
        meta: {
          breadcrumb: 'Vat',
          path: 'vats'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'vats',
            component: require('pages/backoffice/VatList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/VatButtonModal.vue'),
                path: 'add'
              },
              breadcrumb: 'Vat list',
            }
          },
        ]
      },
      {
        path: 'zone-configuration',
        meta: {
          breadcrumb: 'Zone Config',
          path: 'zone-configuration'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'zone-configuration',
            component: require('pages/backoffice/ZoneConfigList.vue'),
            meta: {
              action: {
                component: require('components/structure/ui/actions/CreateEntityButton.vue'),
                path: 'add'
              },
              breadcrumb: 'Zone config list',
            }
          },
          {
            path: 'add',
            name: 'create-zone-config',
            meta: {
              breadcrumb: 'Add',
              hideInMenu: true
            },
            component: require('pages/backoffice/ZoneConfigForm.vue')
          },
          {
            path: ':id',
            meta: {
              breadcrumb: '#ZC',
              source: 'zoneConfigurations',
              hideInMenu: true
            },
            component: require('pages/backoffice/EntityPage.vue'),
            children: [
              {
                path: 'edit',
                name: 'edit-zone-config',

                meta: {
                  hideInMenu: true,
                  source: 'zoneConfigurations',
                  entityComponent: require('pages/backoffice/ZoneConfigForm.vue'),
                  name: 'edit',
                  breadcrumb: 'Edit'
                },
                component: require('pages/backoffice/ZoneConfigForm.vue')
              },
            ]
          },
        ]
      },
      {
        path: 'pages-configuration',
        meta: {
          breadcrumb: 'Pages Config',
          path: 'pages-configuration'
        },
        component: require('pages/backoffice/RouterViewPage.vue'),
        children: [
          {
            path: '',
            name: 'pages-configuration',
            component: require('pages/backoffice/PageConfigList.vue'),
            meta: {
              breadcrumb: '',
              action: {
                component: require('pages/backoffice/CreatePageReveal.vue'),
                path: 'add'
              },
            }
          }

        ]
      },
      {
        path: 'logout',
        name: 'logout',
        meta: {breadcrumb: 'Logout'},
        component: require('pages/backoffice/Logout.vue')
      },
    ]
  },
]


export default [
  {
    path: '/',
    redirect: {name: 'home'}
  },
  {
    path: '/administration',
    component: require('pages/Backoffice.vue'),
    meta: {breadcrumb: 'Backoffice'},
    redirect: {name: 'home'},
    children: routes
  },
  {
    path: 'login',
    name: 'login',
    meta: {breadcrumb: 'Login', hideInMenu: true},
    component: require('pages/LoginPage.vue')
  },
  {
    path: '/hardware-sim',
    meta: {path: 'hwsim'},
    component: require('pages/HwSim.vue')
  }
]



// WEBPACK FOOTER //
// ./src/routes/main.js